/**
 * @prettier
 */

import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { NAV_LOADED } from '~/constants/navConstants';

import { emitUpdateNavDataEvent } from '../helpers';

const SecondaryNavV2 = ({ activeLinkId, activeTertiaryLinkId }) => {
  useEffect(() => {
    const handleInitNavData = () => {
      emitUpdateNavDataEvent({
        activeSecondaryLink: activeLinkId,
        activeTertiaryLink: activeTertiaryLinkId,
      });
    };

    window.addEventListener(NAV_LOADED, handleInitNavData);

    return () => {
      window.removeEventListener(NAV_LOADED, handleInitNavData);
    };
  }, [activeLinkId, activeTertiaryLinkId]);

  return null;
};

SecondaryNavV2.propTypes = {
  activeLinkId: PropTypes.string.isRequired,
  activeTertiaryLinkId: PropTypes.string,
};

export default SecondaryNavV2;
